// extracted by mini-css-extract-plugin
export default {"mediaOriginsSummary":"mediaOriginsSummary__iMSHpx"};